var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.275 1.465A6.321 6.321 0 0 1 12.54 7.464a3.626 3.626 0 1 1-5.073 5.073A6.318 6.318 0 0 1 .378 8.474a6.321 6.321 0 0 1 1.897-7.01Zm8.094 6.16a2.746 2.746 0 0 0-2.74 2.743 2.74 2.74 0 1 0 2.74-2.744Zm.317 3.951v.693h-.875v-.693h.875Zm0-3.208v2.734h-.875V8.368h.875ZM6.832 2.296h-.886v3.689H3.53v.885h3.303V2.296Z",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default ForwardRef;